module.exports = __webpack_public_path__ + "static/media/addcompetency.0860c024.png";